//
//
//
//
//
//
//
//
//
//
//
//
//
import './error.less';
import backBtnGroup from './back-btn-group.vue';
export default {
  name: 'error_content',
  components: {
    backBtnGroup: backBtnGroup
  },
  props: {
    code: String,
    desc: String,
    src: String
  }
};